<template>
  <zm-dialog class="ze-plan-details" width="555px" :visible.sync="visible" show-close :before-close="handleBeforeClose">
    <!--header-->
    <BasePlanDetails>
      <span slot="title">{{ title }}</span>
      <Price slot="price" :currency="currencySymbol" :price="priceInfo.price" :unit="priceInfo.unit"
        :prefix="priceInfo.prefix" :suffix="priceInfo.suffix" />
      <span slot="desc">
        {{ desc }}
      </span>
      <zm-button slot="action" type="link" class="plan-details__confirm-btn text-capitalize" @click="handleSure">
        {{ $t('billing.pbx.plan_details.view_more') }}
      </zm-button>
    </BasePlanDetails>
  </zm-dialog>
</template>
<script type="text/jsx">
import BasePlanDetails from './base.vue';
import Price from '@/components/price.vue';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { BILLING_CYCLE, planTypes, trackingPlanTypes } from '@/common/constants';
import { getCurrency, getCurrencySymbol } from "@/utils/currency";
import { get } from 'lodash';

const PlanDetailsTitleKey = {
  [planTypes.WEBINAR]: {
    [BILLING_CYCLE.ONE_MONTH]: 'billing.webinar.title',
    [BILLING_CYCLE.MONTHLY]: 'billing.webinar.title',
    [BILLING_CYCLE.ANNUAL]: 'billing.webinar.title'
  },
  [planTypes.EVENT_SAAS]: {
    [BILLING_CYCLE.PAY_PER_ATTENDEE]: 'billing.planform.title.eventsaas_consumption',
    [BILLING_CYCLE.MONTHLY]: 'billing.planform.title.zoom_events',
    [BILLING_CYCLE.ANNUAL]: 'billing.planform.title.zoom_events'
  },
  [planTypes.EVENT_SAAS_CORE]: {
    [BILLING_CYCLE.PAY_PER_ATTENDEE]: 'billing.planform.title.eventsaascore_consumption',
    [BILLING_CYCLE.MONTHLY]: 'billing.planform.title.eventsaascore',
    [BILLING_CYCLE.ANNUAL]: 'billing.planform.title.eventsaascore'
  },
};

const PlanDetailsDescKey = {
  [planTypes.WEBINAR]: 'billing.events.plan_details.webinar_desc',
  [planTypes.EVENT_SAAS]: 'billing.events.plan_details.events_desc',
  [planTypes.EVENT_SAAS_CORE]: 'billing.events.plan_details.sessions_desc',
};

const getUnitKey = (cycle) => {
  return {
    [BILLING_CYCLE.ANNUAL]: `billing.common.per_billing_cycle_license.${cycle}`,
    [BILLING_CYCLE.MONTHLY]: `billing.common.per_billing_cycle_license.${cycle}`,
    [BILLING_CYCLE.QUARTERLY]: `billing.common.per_billing_cycle_license.${cycle}`,
    [BILLING_CYCLE.TWO_YEARS]: `billing.common.per_billing_cycle_license.${cycle}`,
    [BILLING_CYCLE.THREE_YEARS]: `billing.common.per_billing_cycle_license.${cycle}`,
    [BILLING_CYCLE.ONE_MONTH]: `billing.common.per_billing_cycle_one_month.${cycle}`
  }[cycle] || '';
};

const getSuffix = function (cycle, capacity, result) {
  return cycle === BILLING_CYCLE.PAY_PER_ATTENDEE
    ? `/${capacity} ${!result ? this.$t('billing.participants') : this.$t('billing.events.attendees', [''])}`
    : `(${capacity} ${!result ? this.$t('billing.participants') : this.$t('billing.events.attendees', [''])})`;
}

export default {
  name: 'PlanDetails',
  mixins: [ConfirmComponent],
  components: {
    Price,
    BasePlanDetails,
  },
  props: {
    selectedPlans: Array,
    planType: String,
    trackingKey: String
  },
  data() {
    return {
      visible: false,
      currencySymbol: getCurrencySymbol(getCurrency()),
    };
  },
  methods: {
    handleSure() {
      this.$tracking.buyInteraction('product details',
        `${this.trackingPlanKey} plan details -  view more`);
    },
    handleBeforeClose() {
      this.$tracking.buyInteraction('product details',
        `${this.trackingPlanKey} plan details - exit`);
      this.handleCancel();
    }
  },
  computed: {
    isEventSaasOrEventSassCore() {
      return this.planType === planTypes.EVENT_SAAS_CORE || this.planType === planTypes.EVENT_SAAS;
    },
    trackingPlanKey() {
      return this.trackingKey ?? get(trackingPlanTypes, get(planTypes, this.planType));
    },
    priceInfo() {
      const { billing_cycle, amount, capacity } = this.firstPlan;
      const price = (amount / 100).toFixed(2);
      return {
        price,
        suffix: getSuffix.call(this, billing_cycle, capacity, this.isEventSaasOrEventSassCore),
        unit: this.$t(getUnitKey(billing_cycle)),
        prefix: this.isMultipleSubscription ? this.$t('billing.common.from') : '',
      }
    },
    firstPlan() {
      return this.selectedPlans?.[0] || {};
    },
    title() {
      const key = PlanDetailsTitleKey?.[this.planType]?.[this.firstPlan.billing_cycle];
      return key && this.$t(key);
    },
    isMultipleSubscription() {
      return this.selectedPlans?.length > 1;
    },
    desc() {
      return this.$t(PlanDetailsDescKey[this.planType]);
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        v && this.$tracking.buyInteraction('product details', `${this.trackingPlanKey} plan details - impression`);
      }
    }
  },
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';

.ze-plan-details {
  .zm-dialog {
    padding: 72px 60px;
  }
}
</style>
